/**
 * A stored `YYYY-MM-DD` day as a person reads it, "Aug 1, 2025". Read as UTC,
 * because that is what it is: formatting it in the reader's zone moves it a
 * day for anyone west of Greenwich.
 */
export function dayLabel(day: string): string {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}

/** The same day without its year, "Oct 12": for a run, which is always recent. */
export function shortDayLabel(day: string): string {
  return new Date(`${day}T00:00:00Z`).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });
}

/**
 * A moment, "Oct 13, 8:28 PM": in the reader's own zone, unlike a day, because
 * it is a time on their clock — when something was queued or happened.
 */
export function momentLabel(iso: string): string {
  return new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
